<template>
  <!-- 留言管理 -->
  <div class="leavingMsg">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['咨讯管理', $route.meta.title]"
    >
      <!-- <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)">新增PC导航</el-button>
      </template> -->
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="意见建议" value="意见建议"></el-option>
          <el-option label="服务投诉" value="服务投诉"></el-option>
          <el-option label="账目异议" value="账目异议"></el-option>
          <el-option label="药品咨询" value="药品咨询"></el-option>
        </el-select>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="未审核" value="1"></el-option>
          <el-option label="已删除" value="-1"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column label="序号" align="center" type="index" width="150">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="留言编号"
      >
      </el-table-column>
      <el-table-column
        prop="userId"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        label="单位名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="content"
        label="留言内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="reply"
        label="回复内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="留言类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">未审核</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">审核通过</el-tag>
          <el-tag type="info" v-if="scope.row.status == -1">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="留言时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="replyTime"
        label="回复时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != -1"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >回复</el-button
          >
          <el-button
            v-show="scope.row.status != -1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, -1)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 留言回复 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">留言回复</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="留言内容" prop="content">
              <el-input
                v-model="addForm.content"
                type="textarea"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="回复内容" prop="reply">
              <el-input v-model="addForm.reply" type="textarea"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "leavingMsg",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        type: "",
        status: "9",
      },
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: "",
        content: "",
        reply: "",
      },
      addFormRule: {
        reply: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        type: "GetMessageBoardList",
        status: this.searchForm.status,
        judge: this.searchForm.type,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Messageboard"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "messageboard/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => ({
              id: item.id, // 留言编号
              userId: item.user_id, // 客户编号
              userName: item.businessname, // 单位名称
              content: item.content, // 留言内容
              reply: item.reply, // 回复内容
              type: item.judge, // 留言类型
              status: item.status, // 状态
              addTime: item.sb_time, // 留言时间
              replyTime: item.sh_time, // 回复时间
            }));
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要删除吗？";
      let type = "error";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == -1) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "UpdateMessageStatus",
            strWhere: row.id,
            status: status,
          };
          let proc = "Proc_Admin_Messageboard"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "messageboard/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "UpdateReply",
            id: this.addForm.id,
            reply: this.addForm.reply,
            content: this.addForm.content,
          };
          let proc = "Proc_Admin_Messageboard"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "messageboard/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.leavingMsg {
  width: 100%;
  height: 100%;
}
</style>
